import React from 'react';

import {map} from 'lodash-es';
import PropTypes from 'prop-types';

import {onSuggestionKeyDown} from 'static/three-oh/src/components/GlobalLayout/GlobalNav/GlobalNavSearch/helpers';
import {
  GlobalNavSearchSuggestionsSection,
  GlobalNavSearchSuggestion,
  SectionHeader,
} from 'static/three-oh/src/components/GlobalLayout/GlobalNav/GlobalNavSearch/JeevesSearchSuggestions/SuggestionParts/SuggestionParts';
import {toSnakeCase} from 'static/three-oh/utils/stringUtils';

import styles from './styles.scss';

const RECOMMENDED_SEARCH_TERMS = [
  'Black History',
  'Amanda Gorman',
  'Harriet Tubman',
  'Stock Market',
  'Poetry',
];

class RecommendedSearches extends React.Component {
  static propTypes = {
    onQueryTermSubmission: PropTypes.func.isRequired,
    trackUserEvent: PropTypes.func.isRequired,
    isGlobalNavSearch: PropTypes.bool.isRequired,
    onSuggestionDismiss: PropTypes.func,
    onSuggestionTab: PropTypes.func,
  };

  static defaultProps = {
    isGlobalNavSearch: false,
  };

  /**
   * Track the submission of a recommended search term.
   * @param {string} recommendedTerm - The selected term.
   * @param {boolean} click - A boolean value indicating whether the event was a click event
   *   (vs a keydown event).
   */
  onRecommendedTermSubmit = (recommendedTerm, click = true) => {
    const eventProperties = {
      term: recommendedTerm,
      recommended_terms: RECOMMENDED_SEARCH_TERMS,
      user_invoked_search: true
    };
    this.props.trackUserEvent('recommendation_submit', eventProperties, click);
    this.props.onQueryTermSubmission(recommendedTerm);
  };

  /**
   * Track keydown events for recommended search terms.
   * @param {Event} event - The keydown event.
   * @param {string} recommendedTerm - The selected term.
   */
  onRecommendedTermKeyDown = (event, recommendedTerm) => {
    const params = {
      event: event,
      onSuggestionSubmit: () => this.onRecommendedTermSubmit(recommendedTerm, false),
      onSuggestionDismiss: this.props.onSuggestionDismiss,
      onSuggestionTab: this.props.onSuggestionTab,
    };
    onSuggestionKeyDown(params);
  };

  render() {
    const {isGlobalNavSearch} = this.props;
    const recommendedTermRows = map(RECOMMENDED_SEARCH_TERMS, (term, index) => {
      return (
        isGlobalNavSearch ?
            (
              <GlobalNavSearchSuggestion
                onClick={() => { this.onRecommendedTermSubmit(term); }}
                onKeyDown={(event) => this.onRecommendedTermKeyDown(event, term)}
                suggestionText={term}
                isStandard={false}
              />
            ) :
            (
              <div
                className={styles.recommendedTerm}
                key={index}
                data-qa-selector={`${toSnakeCase(term)}_suggestion`}
              >
                <p
                  onClick={() => this.onRecommendedTermSubmit(term)}
                  onKeyDown={(event) => this.onRecommendedTermKeyDown(event, term)}
                  tabIndex="0"
                >
                  {term}
                </p>
              </div>
            )
      );
    });

    return (
      isGlobalNavSearch ?
          (
            <GlobalNavSearchSuggestionsSection
              header={<SectionHeader headerTitle="Suggested"/>}
              listItems={recommendedTermRows}
              ariaLabel="Recommended Searches"
              dataQaSelector="recommended_searches_list"
            />
          ) :
          (
            <div className={styles.recommendedTermList}>
              <div
                className={styles.sectionTitle}
                data-qa-selectors="suggested_searches_title"
              >
                <h4>Suggested Searches</h4>
              </div>
              {recommendedTermRows}
            </div>
          )
    );
  }
}

export default RecommendedSearches;
